import Handlebars from "handlebars";

class HandlebarsService {
  private templates: Map<string, HandlebarsTemplateDelegate> = new Map();

  async loadTemplate(name: string): Promise<HandlebarsTemplateDelegate> {
    if (this.templates.has(name)) {
      return this.templates.get(name)!;
    }

    const response = await fetch(`/templates/${name}.html`);
    const templateHtml = await response.text();
    const compiled = Handlebars.compile(templateHtml);
    this.templates.set(name, compiled);
    return compiled;
  }

  async render(name: string, data: Record<string, any>): Promise<string> {
    const template = await this.loadTemplate(name);
    return template(data);
  }
}

export default new HandlebarsService();
